import actionCreatorFactory from "typescript-fsa";
import { ModalDataItem, NotificationItem } from "./types";

const actionCreator = actionCreatorFactory("@@App");

export const appActions = {
  showLoading: actionCreator("SHOW_LOADING"),
  hideLoading: actionCreator("HIDE_LOADING"),
  showModal: actionCreator<ModalDataItem>("SHOW_MODAL"),
  hideModal: actionCreator("HIDE_MODAL"),
  showNotification: actionCreator<NotificationItem>("SHOW_NOTIFICATION"),
  hideNotification: actionCreator("HIDE_NOTIFICATION"),
  showSidebarSP: actionCreator("SHOW_SIDEBAR_SP"),
  hideSidebarSP: actionCreator("HIDE_SIDEBAR_SP"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
